const activityLogEventTypes = [
  'Create',
  'Update',
  'Delete',
];

export default activityLogEventTypes;



// WEBPACK FOOTER //
// ./src/config/activityLogEventTypes.js